import type React from 'react'
import { Button } from '../../../../../../actions/Button'
import { ContentCard } from './Cards/ContentList'
import { DeepDiveCard } from './Cards/DeepDive'
import { FocusCard } from './Cards/Focus'
import { mdxHtmlComponents } from './html'

const reactComponents: Record<string, React.ElementType> = {
  Button: props => (
    <div className='mdx-data-container'>
      <Button {...props} />
    </div>
  ),
  ContentCard: props => (
    <div className='mdx-data-container'>
      <ContentCard {...props} />
    </div>
  ),
  FocusCard: props => (
    <div className='mdx-data-container'>
      <FocusCard {...props} />
    </div>
  ),
  DeepDive: props => (
    <div className='mdx-data-container'>
      <DeepDiveCard {...props} />
    </div>
  )
}

export const mdxComponents: Record<string, React.ElementType> = {
  ...mdxHtmlComponents,
  ...reactComponents
}
